module.exports = __webpack_public_path__ + "static/hero.ddb6d5a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/hero.svg
// module id = 680
// module chunks = 213534597649335